import { render, staticRenderFns } from "./Service23Table.vue?vue&type=template&id=3e022ff3&"
import script from "./Service23Table.vue?vue&type=script&lang=js&"
export * from "./Service23Table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports